import { render, staticRenderFns } from "./CommunityHelp.vue?vue&type=template&id=242edec4&"
import script from "./CommunityHelp.vue?vue&type=script&lang=js&"
export * from "./CommunityHelp.vue?vue&type=script&lang=js&"
import style0 from "./CommunityHelp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports